import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 9.5,
			fill: "#12326E",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.34807 4.23291C6.50137 4.10009 6.72981 4.10304 6.87963 4.23977L10.2379 7.30454C10.5077 7.55074 10.3335 8 9.9683 8H3.07256C2.70224 8 2.53075 7.54017 2.81063 7.29768L6.34807 4.23291Z",
			fill: "#51F5C4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6519 15.7671C13.4986 15.8999 13.2702 15.897 13.1204 15.7602L9.76207 12.6955C9.49228 12.4493 9.66647 12 10.0317 12L16.9274 12C17.2978 12 17.4692 12.4598 17.1894 12.7023L13.6519 15.7671Z",
			fill: "#E73088"
		})
	]
});
export default SvgSub;
